import { apiClient } from '@/core/api/client';

export type NetworkConnection = {
  id: string;
  initiatorUserId: string;
  targetUserId: string;
  isMutual: boolean;
  createdAt: string;
  target: {
    id: string;
    firstName: string | null;
    lastName: string | null;
    email: string;
    role: string;
    serviceProvider?: {
      id: string;
      companyName: string;
      businessAddress: string;
      categories: Array<{
        category: {
          id: string;
          name: string;
        };
      }>;
      specialties: Array<{
        specialty: {
          id: string;
          name: string;
        };
      }>;
    };
    financialAdvisor?: {
      id: string;
      companyName: string;
    };
  };
};

export type NetworkStats = {
  totalConnections: number;
};

export type CheckConnectionResponse = {
  isConnected: boolean;
};

/**
 * Add a user to the network
 */
export const addToNetwork = async (targetUserId: string): Promise<NetworkConnection> => {
  const response = await apiClient.post('/network', { targetUserId });
  return response.data;
};

/**
 * Remove a user from the network
 */
export const removeFromNetwork = async (targetUserId: string): Promise<void> => {
  await apiClient.delete(`/network/${targetUserId}`);
};

/**
 * Get all connections in the user's network
 */
export const getMyNetwork = async (): Promise<NetworkConnection[]> => {
  const response = await apiClient.get('/network');
  return response.data;
};

/**
 * Check if a user is in the network
 */
export const checkConnection = async (targetUserId: string): Promise<CheckConnectionResponse> => {
  const response = await apiClient.get(`/network/check/${targetUserId}`);
  return response.data;
};

/**
 * Get network statistics
 */
export const getNetworkStats = async (): Promise<NetworkStats> => {
  const response = await apiClient.get('/network/stats');
  return response.data;
};

